import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// SLOT PHOTO — le client remplacera `src` par ses propres visuels (univers Six Senses / Hoy / Soho / Lily of the Valley)
export default function PhotoSlot({ src, index, caption, ratio = "aspect-[4/5]", speed = 50, className = "", rounded = "rounded-[28px]" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-speed, speed]);

  return (
    <motion.figure
      ref={ref}
      data-testid={`photo-slot-${index}`}
      initial={{ opacity: 0, scale: 0.96, y: 24 }}
      whileInView={{ opacity: 1, scale: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative overflow-hidden ${rounded} ${ratio} ${className}`}
    >
      <motion.img
        src={src}
        alt={caption}
        loading="lazy"
        style={{ y }}
        className="absolute left-0 -top-[10%] h-[120%] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
      />
    </motion.figure>
  );
}
